<template>
    <div>
        <b-modal size="xl" id="modal-prepare-question" class="modal-dialog b-modal-xxl" no-close-on-backdrop hide-footer
            ref="modal-create-update-prepare-quesion" @hidden="resetModal">


            <div class="container wrap-form-create-update-chapter">
                <div class="action_close_modal">
                    <img class="icon-close float-right cursor-pointer" style="width: 15px;" src="@/assets/img/x.png"
                        @click="handleHideModal" />
                </div>
                <h4 v-if="!isEditNameDocument">
                    <strong>{{ getNameTitle }}</strong>
                    <div class="action_change_name float-right">
                        <button class="btn btn-change" @click="handleEditNameDocument">Chỉnh sửa tên</button>
                    </div>
                </h4>
                <div v-else class="display-flex">
                    <div class="row">
                        <div class="col-md-6">
                            <b-form-input id="numberLesson" v-model="nameDocument" type="text"
                                placeholder="Nhập tên bài giảng" autocomplete="off" class="form-control" />
                        </div>
                        <div class="col-md-6">
                            <a href="javascript:;" class="primary-color-txt font-size-17 btn-cancel"
                                @click="handleCancelEditNameDocument">Hủy</a>
                            <a @click="handleUpdateNameDocument()" href="javascript:;"
                                class="btn btn-agree font-size-17 btn-delete">Đồng ý</a>
                        </div>
                    </div>
                </div>

                <b-tabs pills>
                    <b-tab @click="handleChangeTab(tabCreateQuestion)" title="Soạn câu hỏi"
                        :active="tabActive == tabCreateQuestion">
                        <b-form id="form-create-update-chapter" @submit.prevent="handleSave">
                            <div class="form-group row">
                                <div class="col-md-12">
                                    Số câu: {{ listQuestionSave.length }}
                                </div>
                            </div>
                            <div class="row form-group">
                                <div class="col-md-12 col-lg-8 col-xl-6">
                                    <a href="javascript:;" @click="handleAddQuestion"
                                        class="item btn btn-main border-rd-10 margin-5 font-size-16 item__add">
                                        <img class="icon-plus" src="@/assets/img/plus.png" />
                                        <img class="icon-plus" src="@/assets/img/plus-hover.png" />
                                        Tạo câu hỏi mới
                                    </a>
                                </div>
                            </div>

                            <!--  -->
                            <div class="pb-3" v-for="(question, index) of listQuestion" :key="index">
                                <div class="justify-content-right">
                                    <a :disabled="isDisabledButton" href="javascript:;" @click="saveQuestion(question)"
                                        class="item btn btn-main border-rd-10 margin-5 font-size-16 item__add">
                                        Hoàn thành
                                    </a>

                                </div>

                                <div class="row form-group pb-3">
                                    <div class="col-md-12 col-lg-3 col-xl-2 display-flex-column rg-1 mb-3">
                                        <div class="question-title">Câu hỏi: {{ index + 1 }}</div>
                                        <select class="custom-select border-rd-10">
                                            <option value="1" selected="selected">Trắc nghiệm</option>
                                        </select>

                                    </div>
                                    <div class="question-head col-md-12 col-lg-7 col-xl-8 mb-3">
                                        <div class="question-head__row">
                                            <EditorCKNew @onEditorChange="onEditorChangeQuestion"
                                                :contentEditor="question.content" :position="index" />
                                        </div>
                                    </div>

                                    <div v-for="(answer, indexAnswer) of question.listAnswer" :key="indexAnswer"
                                        class="item display-flex-center justify-content-between item-answer cg-1 col-md-12 mt-3">
                                        <div class="row">
                                            <div class="item__first col-md-12 col-lg-3 col-xl-2">
                                                <div class="answer-correct display-flex">
                                                    <b-checkbox :id="'b-answer_' + index + indexAnswer"
                                                        v-model="answer.isTrue">
                                                    </b-checkbox>
                                                    <label class="display-flex-column cursor-pointer"
                                                        :for="'b-answer_' + index + indexAnswer">
                                                        <strong>Đáp án {{ answer.code }}</strong>
                                                        <span class="font-size-12 text-subtitle">Hãy tích để chọn làm
                                                            đáp án đúng</span>
                                                    </label>
                                                </div>
                                            </div>
                                            <div class="col-md-12 col-lg-7 col-xl-8 display-flex-center cg-1">
                                                <EdittorCKAnswerNew @onEditorChange="onEditorChangeAnswer"
                                                    :contentEditor="answer.content" :position="answer.idClient" />

                                                <div class="item__img">
                                                    <div v-if="answer.fileAnswer.url" class="image-question">
                                                        <img :style="{ 'width': question.withSize + 'px', 'height': question.heightSize + 'px' }"
                                                            :src="answer.fileAnswer.url" />
                                                        <b-button @click="onDeleteFileAnswer(question, answer)"
                                                            type="button" class="btn-delete-image-question">
                                                            <i aria-label="icon: close" class="anticon anticon-close">
                                                                <svg viewBox="64 64 896 896" data-icon="close"
                                                                    width="1em" height="1em" fill="currentColor"
                                                                    aria-hidden="true" focusable="false" class="">
                                                                    <path
                                                                        d="M563.8 512l262.5-312.9c4.4-5.2.7-13.1-6.1-13.1h-79.8c-4.7 0-9.2 2.1-12.3 5.7L511.6 449.8 295.1 191.7c-3-3.6-7.5-5.7-12.3-5.7H203c-6.8 0-10.5 7.9-6.1 13.1L459.4 512 196.9 824.9A7.95 7.95 0 0 0 203 838h79.8c4.7 0 9.2-2.1 12.3-5.7l216.5-258.1 216.5 258.1c3 3.6 7.5 5.7 12.3 5.7h79.8c6.8 0 10.5-7.9 6.1-13.1L563.8 512z">
                                                                    </path>
                                                                </svg></i>
                                                        </b-button>
                                                    </div>
                                                    <div v-else class="answer-img position-rel">
                                                        <input hidden type="file" :ref="answer.idClient"
                                                            accept="image/*"
                                                            @change="changeImgAnswer($event, question, answer)">
                                                        <b-button @click="handUploadImageAnswer(answer)"
                                                            class="btn-select-image-question" type="button"
                                                            icon="upload">
                                                            <img class="icon-file" src="@/assets/img/icon-file.png"
                                                                alt />
                                                            Tải ảnh
                                                        </b-button>
                                                    </div>
                                                </div>
                                                <a @click="onDeleteAnswer(question, answer)" class="">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                        viewBox="0 0 24 24" fill="none">
                                                        <path d="M18 6L6 18" stroke="#DC3545" stroke-width="2"
                                                            stroke-linecap="round" stroke-linejoin="round" />
                                                        <path d="M6 6L18 18" stroke="#DC3545" stroke-width="2"
                                                            stroke-linecap="round" stroke-linejoin="round" />
                                                    </svg>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-12">
                                        <button @click="handleAddAnswer(question)" type="button"
                                            class="border-rd-20 font-size-16 form-30h display-flex-center cg-1 line-height-1 btn-add-answer">
                                            <img class="icon-plus" src="@/assets/img/plus-hover.png" />
                                            Thêm mới câu trả lời
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <!--  -->
                            <div class="row">
                                <div class="question-item col-md-12 margin-top-10"
                                    v-for="(question, index) of listQuestionSave" :key="index">
                                    <div class="wrap-title-header display-flex justify-content-space-between">
                                        <div class="display-flex">
                                            <strong>Câu hỏi {{ index + 1 }}:</strong>&nbsp;<strong
                                                class="title-question" v-html="question.content"></strong>
                                        </div>
                                        <div class="display-flex">
                                            <a href="javascript:;" @click="handleOnDeleteQuestion(question)"
                                                class="item btn btn-main btn-delete-question border-rd-10 margin-5 font-size-16 item__add">
                                                Xóa câu hỏi
                                            </a>
                                            &nbsp;
                                            <a href="javascript:;" @click="handleEditQuestion(question)"
                                                class="item btn btn-main border-rd-10 margin-5 font-size-16 item__add">
                                                Chỉnh sửa
                                            </a>
                                        </div>

                                    </div>

                                    <div class="wrap-list-answer">
                                        <div class="answer-item" v-for="(answer, indexAnswer) of question.listAnswer"
                                            :key="indexAnswer">
                                            <b-form-checkbox :checked="answer.isTrue" disabled>
                                                <div
                                                    v-html="`<span class='display-flex'>${answer.code}.&nbsp;${answer.content}</span>`">
                                                </div>
                                            </b-form-checkbox>
                                        </div>

                                    </div>

                                </div>
                            </div>

                            <div class="form_action display-flex justity-content-center cg-1 mt-4">
                                <button type="button"
                                    class="btn btn-outline-primary b-btn-width font-size-16 font-sanpro-semibold"
                                    :disabled="isLoading" @click="handleHideModal">
                                    Hủy bỏ
                                </button>
                                <button type="submit"
                                    class="btn btn-primary b-btn-width font-size-16 font-sanpro-semibold"
                                    :disabled="isDisabledButton">
                                    {{ documentId > 0 ? 'Lưu' : 'Thêm mới' }}
                                </button>
                            </div>
                        </b-form>
                    </b-tab>
                    <b-tab @click="handleChangeTab(tabUploadDocx)" title="Tạo từ file docx"
                        :active="tabActive == tabUploadDocx">
                        <div class="container">
                            <div class="row block_upload_file">
                                <input hidden type="file" name="file" id="fileInputUpload" class="hidden-input"
                                    ref="file" accept=".pptx,.docx,.xlsx,.pdf,.h5p" @change="onChangeUploadFile" />
                                <div v-if="!(formWord.file || formWord.fileName)" class="col-md-4 upload-file"
                                    @dragover="dragoverUploadFile" @dragleave="dragleaveUploadFile"
                                    @drop="dropUploadFile" :class="isDragging ? 'upload-drag' : ''">
                                    <div class="justify-content-center tittle">
                                        <div @click="onUploadFile">
                                            <h4><strong>Tải file lên tại đây</strong></h4>
                                        </div>
                                    </div>

                                    <div class="row col-md-5">
                                        <div class="text-center block_icon_upload" @click="onUploadFile">
                                            <img class="icon-upload" src="@/assets/img/upload.png" />
                                        </div>
                                    </div>

                                </div>
                                <div v-else-if="(formWord.file || formWord.fileName)" class="col-md-6 upload-file">
                                    <label for="name" class="">File tài liệu:</label>
                                    <div class="wrap-file-data display-flex justify-content-space-between">

                                        <div class="wrap-left display-flex">
                                            <img class="icon-photo margin-right-10" src="@/assets/img/photo.png" />
                                            <div class="name-file">
                                                {{ formWord.file ? formWord.file.name : formWord.fileName }}
                                            </div>
                                        </div>
                                        <div class="wrap-right display-flex">
                                            <div class="size-file margin-right-10">{{ formatSizeFile(formWord.sizeFile)
                                                }}
                                            </div>
                                            <img @click="handleOnRemoveFile" class="btn-delete"
                                                src="@/assets/img/icon-close.png" />
                                        </div>
                                    </div>

                                </div>
                            </div>

                        </div>

                    </b-tab>

                </b-tabs>


            </div>

        </b-modal>

        <b-modal id="modal-prevent-closing" class="header-modal" no-close-on-backdrop hide-footer
            ref="modal-confirm-document-prepare-question">
            <div class="container modal-confirm__body">
                <h4>
                    <strong>
                        Thông tin bài giảng của bạn chưa được lưu. Bạn có chắc chắn muốn thoát?
                    </strong>
                </h4>
                <p class="font-size-17 primary-color-txt font-sanpro-light py-2">
                    Nếu bạn xác nhận thoát, mọi dữ liệu về chỉnh sửa bài bài giảng của bạn sẽ không được lưu trữ
                </p>
                <div class="modal__actions text-center">
                    <a href="javascript:;" class="primary-color-txt font-size-17 btn btn-outline-secondary btn-no mr-3"
                        @click="handleHideModalConfim">Không</a>
                    <a href="javascript:;" class="btn btn-primary font-size-17 font-sanpro-semibold btn-delete"
                        @click="handleConfimModal()">Xác nhận</a>
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
import { saveLessonQuestionClassSchool, getDetail, deleteLessonQuestionClassSchool } from './../../../_api/lessonQuestionClassSchoolServices'
import EditorCK from '@/components/EditorCK.vue'
import EditorCKNew from '@/components/EditorCKNew.vue'
import EdittorCKAnswer from '@/components/EdittorCKAnswer.vue'
import EdittorCKAnswerNew from '@/components/EdittorCKAnswerNew.vue'
import { APP_CONFIG } from "@/utils/constants";
import { updateNameDocument } from './../../../_api/documentClassSchoolServices'
import { uploadFileLessonQuestionClassSchool, getQuestionByDoc } from './../../../_api/lessonQuestionClassSchoolServices'
export default {
    props: {
        documentId: {
            type: Number,
            default: 0
        },
        documentName: {
            type: String,
            default: ''
        }
    },
    components: {
        EditorCK,
        EditorCKNew,
        EdittorCKAnswer,
        EdittorCKAnswerNew
    },
    watch: {
        'form.sizeImage': 'setSizeImageQuestion'
    },
    data() {
        return {
            isDisabledButton: false,
            tabActive: 1,
            tabCreateQuestion: 1,
            tabUploadDocx: 2,
            confirmActive: {},
            submitted: false,
            isLoading: false,



            listQuestion: [],

            cdnUrl: APP_CONFIG.bookCdnUrl + 'data/lesson/',
            listAnswerDelete: [],
            //kích xỡ ảnh câu hỏi

            question_img_size: [
                { value: 4, text: '456x336' },
                { value: 3, text: '1032x584' },
                { value: 2, text: '1032x176' },
                { value: 1, text: '240x176' }
            ],
            answer_key_text: [
                'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'X', 'W', 'Y', 'Z'
            ],
            nameDocument: '',
            isEditNameDocument: false,
            formWord: {
                fileName: '',
                file: null,
            },
            listQuestionSave: [],
            form: {
                id: 0,
                lessonClassSchoolId: 0,
                chapterId: 0,
                postId: 0,
                name: '',
                typeDocument: '',
                fileName: '',
                pathFile: '',
                link: '',
                sizeFile: 0,
                file: null, //lưu trữ file upload
            },
            isDragging: false,

        }
    },
    validations() {
        return {
            // form: {
            //     topicName:{
            //         required
            //     }
            // }
        }
    },
    computed: {
        screenWidth() {
            return window.innerWidth;
        },
        getNameTitle() {
            return this.documentName
        }
    },
    mounted() {
        // if (this.documentId > 0) {
        //     //get detail
        //     this.getDetailChapterClassSchool()
        // }
        this.handleShowModal()

        this.getDetailQuestion()
    },
    methods: {
        handleEditQuestion(question) {
            this.listQuestion = [{ ...question }]
        },
        saveQuestion(question) {
            if (question.content) {
                this.saveListQuestion([question], false)
            }
            else {
                this.$toast.error('Vui lòng nhập câu hỏi')
            }
        },
        getKeyText(numberQuestion) {
            if (numberQuestion > 24) {
                numberQuestion = 0
            }
            return this.answer_key_text[numberQuestion]
        },
        handleChangeTab(tab) {
            this.tabActive = tab
        },
        handleAddQuestion() {
            this.addData()
        },
        addData() {
            let data = {
                id: 0,
                idClient: this.generateUUID(),
                lessonClassSchoolId: this.$route.query.id,
                topicName: '', // tên đề bài
                sizeImage: 1, // kích cỡ ảnh
                withSize: 240,
                heightSize: 176,
                fileQuestion: {
                    fileData: null,
                    url: ''
                },
                content: '',
                listAnswer: [],

            }
            //         let data = {
            // "id": 0,
            // "idClient": this.generateUUID(),
            // "lessonClassSchoolId": "161",
            // "topicName": "",
            // "sizeImage": 1,
            // "withSize": 240,
            // "heightSize": 176,
            // "fileQuestion": {
            //     "fileData": null,
            //     "url": ""
            // },
            // "content": "<p>c&acirc;u hỏi 1</p>\n",
            // "listAnswer": [
            //     {
            //         "id": 0,
            //         "idClient": this.generateUUID(),
            //         "isTrue": false,
            //         "content": "<p>câu trả lời 1</p>",
            //         "fileAnswer": {
            //             "fileData": null,
            //             "url": ""
            //         },
            //         'code':this.getKeyText(0)
            //     },
            //     {
            //         "id": 0,
            //         "idClient": this.generateUUID(),
            //         "isTrue": true,
            //         "content": "<p>câu trả lời 2</p>",
            //         "fileAnswer": {
            //             "fileData": null,
            //             "url": ""
            //         },
            //         'code':this.getKeyText(1)
            //     }
            // ]
            //}
            this.listQuestion.unshift(data)
        },
        generateUUID() { // Public Domain/MIT
            var d = new Date().getTime();
            if (typeof performance !== 'undefined' && typeof performance.now === 'function') {
                d += performance.now(); //use high-precision timer if available
            }
            var newGuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                var r = (d + Math.random() * 16) % 16 | 0;
                d = Math.floor(d / 16);
                return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
            });

            return newGuid;
        },
        onChangeUploadFile() {
            this.formWord.file = this.$refs.file.files[0]
            this.formWord.sizeFile = this.formWord.file.size
            this.formWord.fileName = this.formWord.file.name
            const formData = new FormData();
            formData.append('file', this.formWord.file)
            getQuestionByDoc(formData).then((res) => {
                if (res && res.data && !res.errors) {
                    if (res.data.length == 0) {
                        this.tabActive = this.tabCreateQuestion
                        this.listQuestion = []
                        this.addData()
                    }

                    for (let i = 0; i < res.data.length; i++) {
                        this.listQuestion = []


                        for (let i = 0; i < res.data.length; i++) {
                            const item = res.data[i];
                            let listAnswer = []
                            for (let j = 0; j < item.answers.length; j++) {
                                const element = item.answers[j];
                                let answer = {
                                    id: element.id,
                                    idClient: this.generateUUID(),
                                    isTrue: element.correct ? true : false,
                                    content: element.content,
                                    fileAnswer: {
                                        fileData: null,
                                        url: '',
                                    },
                                    code: element.code
                                }
                                listAnswer.push(answer)
                            }


                            let question = {
                                id: item.id,
                                idClient: this.generateUUID(),
                                lessonClassSchoolId: this.$route.query.id,
                                topicName: '', // tên đề bài
                                sizeImage: 1, // kích cỡ ảnh
                                withSize: 240,
                                heightSize: 176,
                                fileQuestion: {
                                    fileData: null,
                                    url: item.path ? `${this.cdnUrl}${item.path}` : '',
                                },
                                content: item.content,
                                listAnswer: listAnswer,
                            }
                            this.listQuestion.push(question)
                        }
                        this.tabActive = this.tabCreateQuestion
                    }
                }
            })
        },
        getDetailQuestion() {
            let self = this
            let params = {
                lessonClassSchoolId: this.$route.query.id,
                documentId: this.documentId
            }
            getDetail(params).then(res => {
                if (res && res.data && !res.errors) {
                    this.listQuestionSave = []


                    for (let i = 0; i < res.data.length; i++) {
                        const item = res.data[i];
                        let listAnswer = []
                        for (let j = 0; j < item.listLessonAnswerClassSchoolModels.length; j++) {
                            const element = item.listLessonAnswerClassSchoolModels[j];
                            let answer = {
                                id: element.id,
                                idClient: this.generateUUID(),
                                isTrue: element.isTrue,
                                content: element.content,
                                fileAnswer: {
                                    fileData: null,
                                    url: element.path ? `${this.cdnUrl}${element.path}` : '',
                                },
                                code: element.code
                            }
                            listAnswer.push(answer)
                        }


                        let question = {
                            id: item.id,
                            idClient: this.generateUUID(),
                            lessonClassSchoolId: item.lessonClassSchoolId,
                            topicName: '', // tên đề bài
                            sizeImage: 1, // kích cỡ ảnh
                            withSize: 240,
                            heightSize: 176,
                            fileQuestion: {
                                fileData: null,
                                url: ''
                            },
                            content: item.content,
                            listAnswer: listAnswer,
                        }
                        this.listQuestionSave.push(question)
                    }
                }
            })

            if (this.listQuestion.length == 0) {
                this.addData()
            }
        },
        handleSave() {
            // form: {
            //     id: 0,
            //     lessonClassSchoolId: 0,
            //     topicName: '', // tên đề bài
            //     sizeImage: 1, // kích cỡ ảnh
            //     withSize: 240,
            //     heightSize: 176,
            //     fileQuestion: {
            //         fileData: null,
            //         url: ''
            //     },
            //     content: '',
            //     listAnswer: []
            // },
            this.submitted = true
            if (!this.$v.$invalid) {
                let isValid = true
                let listQuestion = [...this.listQuestion]
                for (let i = 0; i < listQuestion.length; i++) {
                    const element = listQuestion[i];
                    if (!element.content) {
                        isValid = false
                        break
                    }
                }
                if (isValid) {
                    this.saveListQuestion(listQuestion, true)
                }
                else {
                    this.$toast.error('Vui lòng nhập câu hỏi')
                }
            }
        },
        saveListQuestion(listQuestion, isClear = false) {
            let self = this
            const formData = new FormData();
            //return
            formData.append(`countQuestion`, listQuestion.length);
            formData.append(`listAnswerDelete`, this.listAnswerDelete.join(","));
            for (let i = 0; i < listQuestion.length; i++) {
                const item = listQuestion[i];
                formData.append(`id_${i}`, item.id);
                formData.append(`idClient_${i}`, item.idClient);
                formData.append(`lessonClassSchoolId_${i}`, item.lessonClassSchoolId);
                formData.append(`documentId_${i}`, this.documentId);
                formData.append(`topicName_${i}`, item.topicName);
                formData.append(`withSize_${i}`, item.withSize);
                formData.append(`heightSize_${i}`, item.heightSize);
                formData.append(`content_${i}`, item.content);
                formData.append(`countAnswer_${i}`, item.listAnswer.length);
                formData.append(`file_${i}`, item.fileQuestion.fileData);


                for (let a = 0; a < item.listAnswer.length; a++) {
                    const answer = item.listAnswer[a];
                    formData.append(`id_${i}_${a}`, answer.id);
                    formData.append(`questionIdClient_${i}_${a}`, item.idClient);
                    formData.append(`isTrue_${i}_${a}`, answer.isTrue);
                    formData.append(`content_${i}_${a}`, answer.content);
                    formData.append(`file_${i}_${a}`, answer.fileAnswer.fileData);
                    formData.append(`code_${i}_${a}`, answer.code);
                }
            }
            self.isDisabledButton = true
            saveLessonQuestionClassSchool(formData).then(res => {
                if (res && res.data && !res.errors) {
                    self.$toast.success('Cập nhật tài liệu thành công')
                    self.getDetailQuestion()
                    if (!isClear) {
                        for (let q = 0; q < self.listQuestion.length; q++) {
                            const item = self.listQuestion[q];
                            for (let i = 0; i < listQuestion.length; i++) {
                                let itemQuestion = listQuestion[i];
                                if (itemQuestion.idClient == item.idClient) {
                                    self.listQuestion.splice(q, 1)
                                }
                            }

                        }
                    }
                    else {
                        self.listQuestion = []
                    }


                    if (self.listQuestion.length == 0) {
                        self.addData()
                    }
                }
                self.isDisabledButton = false
            })
        },
        answerDefault(index) {
            return {
                id: 0,
                idClient: this.generateUUID(),
                isTrue: false,
                content: '',
                fileAnswer: {
                    fileData: null,
                    url: ''
                },
                code: this.getKeyText(index)
            }
        },
        onEditorChangeQuestion(data) {
            let questionSeleced = this.listQuestion[data.position]
            questionSeleced.content = data.html
        },
        onEditorChangeAnswer(data) {

            for (let iq = 0; iq < this.listQuestion.length; iq++) {
                const question = this.listQuestion[iq];
                for (let ia = 0; ia < question.listAnswer.length; ia++) {
                    let answer = question.listAnswer[ia];
                    if (answer.idClient == data.position) {
                        answer.content = data.html
                        break
                    }
                }
            }
        },
        onDeleteAnswer(question, itemSelectd) {
            for (let i = 0; i < question.listAnswer.length; i++) {
                const item = question.listAnswer[i];
                if (itemSelectd.idClient == item.idClient) {
                    if (item.id > 0) {
                        this.listAnswerDelete.push(item.id)
                    }
                    question.listAnswer.splice(i, 1)
                }
            }
        },
        onDeleteFileAnswer(question, itemCurrent) {
            console.log(question, itemCurrent)
            for (let i = 0; i < question.listAnswer.length; i++) {
                let item = question.listAnswer[i];
                if (itemCurrent.idClient == item.idClient) {
                    item.fileAnswer.fileData = null
                    item.fileAnswer.url = null
                    this.$refs[item.idClient].value = ''
                    break
                }
            }
        },
        changeImgAnswer(e, question, itemCurrent) {
            for (let i = 0; i < question.listAnswer.length; i++) {
                const item = question.listAnswer[i];
                if (itemCurrent.idClient == item.idClient) {
                    item.fileAnswer.fileData = this.$refs[item.idClient][0].files[0]
                    item.fileAnswer.url = URL.createObjectURL(item.fileAnswer.fileData);
                    break
                }
            }

        },
        handUploadImageAnswer(item) {
            this.$refs[item.idClient][0].click()
        },
        handleAddAnswer(question) {
            question.listAnswer.push(this.answerDefault(question.listAnswer.length))
        },

        generateUUID() { // Public Domain/MIT
            var d = new Date().getTime();
            if (typeof performance !== 'undefined' && typeof performance.now === 'function') {
                d += performance.now(); //use high-precision timer if available
            }
            var newGuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                var r = (d + Math.random() * 16) % 16 | 0;
                d = Math.floor(d / 16);
                return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
            });

            return newGuid;
        },
        onDeleteFileQuestion() {
            this.form.fileQuestion.fileData = null
            this.form.fileQuestion.url = ''
            this.$refs.fileImageQuestion.value = ''
        },
        //

        onUploadFile() {
            this.$refs.file.click()
        },
        handleEditNameDocument() {
            this.nameDocument = this.documentName
            this.isEditNameDocument = true
        },
        handleUpdateNameDocument() {
            this.documentName = this.nameDocument
            let self = this
            updateNameDocument({ Id: this.documentId, Name: this.nameDocument }).then(res => {
                if (res && res.data && !res.errors) {
                    self.$toast.success('Cập nhật tên tài liệu thành công')
                    self.handleCancelEditNameDocument()
                }
            })
        },
        handleCancelEditNameDocument() {
            this.isEditNameDocument = false
        },
        handleOnRemoveFile() {
            this.$refs.file.value = '';
            this.formWord.file = null
            this.formWord.pathFile = ''
            this.formWord.fileName = ''
            console.log('clear')
        },
        formatSizeFile(data, to = 'MB') {
            const const_term = 1024;

            // Convert the values and concatenate 
            // the appropriate unit 
            if (to === "KB") {
                return (data / const_term).toFixed(3) + "KB";
            } else if (to === "MB") {
                return (data / const_term ** 2).toFixed(3) + "MB";
            } else if (to === "GB") {
                return (data / const_term ** 3).toFixed(3) + "GB";
            } else if (to === "TB") {
                return (data / const_term ** 4).toFixed(3) + "TB";
            } else {
                return "";
            }
        },
        dragoverUploadFile(e) {
            e.preventDefault();
            this.isDragging = true;
        },
        dragleaveUploadFile() {
            this.isDragging = false;
        },
        dropUploadFile(e) {
            e.preventDefault();
            this.$refs.file.files = e.dataTransfer.files;
            this.onChangeUploadFile();
            this.isDragging = false;
        },
        handleSaveDocument() {
            let self = this
            if (!this.$v.$invalid) {
                const formData = new FormData();
                console.log(this.form)
                formData.append('file', this.form.file);
                uploadFileLessonQuestionClassSchool(formData).then(res => {
                    if (res && res.data && !res.errors) {
                        self.$toast.success('Thêm mới tài liệu thành công')
                    }
                })
            }
        },
        handleOnDeleteQuestion(question) {
            console.log(question)
            let self = this
            deleteLessonQuestionClassSchool(question.id).then(res => {
                if (res && res.data && !res.errors) {
                    self.$toast.success('Xóa câu hỏi thành công')
                    self.getDetailQuestion()
                    //self.listQuestion = []
                    //self.addData()
                    for (let q = 0; q < self.listQuestion.length; q++) {
                        const item = self.listQuestion[q];
                        if (question.idClient == item.idClient) {
                            self.listQuestion.splice(q, 1)
                        }
                    }
                    if (self.listQuestion.length == 0) {
                        self.addData()
                    }
                }
            })
            // for (let i = 0; i < this.listQuestion.length; i++) {
            //     const item = this.listQuestion[i];
            //     if (question.id == item.id) {
            //         this.listQuestion.splice(i, 1)
            //         if (question.id > 0) {
            //             // Call api delete question

            //         }

            //         break
            //     }
            // }
        },
        //
        setSizeImageQuestion() {
            switch (this.form.sizeImage) {
                case 1://'240x176'
                    this.form.withSize = 240
                    this.form.heightSize = 176
                    break;
                case 2: //'1032x176'
                    this.form.withSize = 1032
                    this.form.heightSize = 176
                    break;
                case 3: //'1032x584'
                    this.form.withSize = 1032
                    this.form.heightSize = 584
                    break;
                case 4: //'456x336'
                    this.form.withSize = 456
                    this.form.heightSize = 336
                    break;
                default:
                    break;
            }
        },
        onUploadImageQuestion() {
            this.$refs.fileImageQuestion.click()
        },
        changeImgQuestion() {
            this.form.fileQuestion.fileData = this.$refs.fileImageQuestion.files[0]
            this.form.fileQuestion.url = URL.createObjectURL(this.form.fileQuestion.fileData);
        },
        // getDetailChapterClassSchool() {
        //     let self = this
        //     getDetail(this.documentId).then(res => {
        //         if (res && res.data && !res.errors) {
        //             self.form = {
        //                 id: res.data.id,
        //                 lessonClassSchoolId: res.data.lessonClassSchoolId,
        //                 name: res.data.name,
        //             }
        //         }
        //     })
        // },

        resetModal() {
            this.submitted = false
            this.form = {
                id: 0,
                lessonClassSchoolId: 0,
                topicName: '', // tên đề bài
                sizeImage: 1, // kích cỡ ảnh
                withSize: 240,
                heightSize: 176,
                fileQuestion: {
                    fileData: null,
                    url: ''
                },
                content: '',
                listAnswer: []
            }
        },
        handleDone() {
            this.handleHideModal()
            this.$emit('handleDone')
        },
        handleHideModalConfim() {
            //
            this.$refs['modal-confirm-document-prepare-question'].hide()
        },
        handleShowModalConfim() {
            //
            this.$refs['modal-confirm-document-prepare-question'].show()
        },
        toggleModal() {
            // We pass the ID of the button that we want to return focus to
            // when the modal has hidden
            this.$refs['modal-create-update-prepare-quesion'].toggle('#toggle-btn')
        },
        handleConfimModal() {
            this.$emit('closeModal')
        },
        handleHideModal() {
            //this.$refs['modal-create-update-prepare-quesion'].hide()
            //this.$emit('closeModal')

            // check đã lưu các câu hỏi chưa
            // let isSaveAllQuestion = true
            // for (let i = 0; i < this.listQuestion.length; i++) {
            //     if (this.listQuestion[i].content !== '') {
            //         isSaveAllQuestion = false
            //     }
            // }
            // if (isSaveAllQuestion) {
            //     this.$emit('closeModal')
            // } else {
            //     this.handleShowModalConfim()
            // }
            this.handleShowModalConfim()
        },
        handleShowModal() {
            this.$refs['modal-create-update-prepare-quesion'].show()
        },
    }
}
</script>
<style lang="scss" scoped>
.margin-top-10 {
    margin-top: 10px;
}

.justify-content-space-between {
    justify-content: space-between;
}

.icon-plus {
    width: 20px;
    display: inline-block;
}

.item__add {
    line-height: 18px;
}

.modal-confirm__body {
    padding: 20px;
    background-color: white;

    .modal__actions {

        .btn-delete {
            color: white;
            border-radius: 8px;
            min-width: 8rem;
            font-family: sans-serif;
            height: auto;
            padding: 0.2rem;
        }

        .btn-no {
            border-radius: 8px;
            min-width: 8rem;
            font-family: sans-serif;
            height: auto;
            padding: 0.2rem;

            &:hover {
                color: #ffffff;
            }
        }

        .btn-cancel {
            margin-right: 10px;
            font-family: sans-serif;
        }
    }
}

.item-answer {
    margin-top: 10px;
}

.btn-add-answer {
    display: inline-block;
    margin-top: 10px;
    margin-bottom: 10px;
    border: 0;
    background: none;
}

.text-center {
    text-align: center;
}

.btn-delete-image-question {
    background: red;
    border: 1px solid red;
    color: #fffcfc;
    border-radius: 20px;
}

.wrap-form-create-update-chapter {
    background-color: white;
}

.justify-content-space-between {
    justify-content: space-between
}

.btn-select-image-question {
    border: 1px solid #f0f0f0;
    color: black;
    background: #f0f0f0;

    .icon-file {
        width: 10px;
    }
}

.btn-complete-question {
    border-radius: 10px;
    border: 1px solid #84d7ff;
    padding: 0.25rem 0.5rem;
    background: #84d7ff;

    &:hover {
        background: #007bff;
    }
}

.w-100px {
    width: 100px;
}

.question-title {
    border: 1px solid #ced4da;
    border-radius: 10px;
    padding: 0.5rem 1rem;
}

.item__img {
    min-width: 82px;
}


.font-size-12 {
    font-size: 12px !important;
}

.b-btn-width {
    min-width: 8rem;
    height: auto;
    padding: 0.3rem;
    border-radius: 8px;
}

.float-right {
    float: right;
}

.wrap-form-create-update-chapter {
    padding: 30px !important;
}

.btn-change {
    border: none;
    background-color: #d7f0fe;
    color: black;
    padding: 0px 4px;
    margin-right: 40px;
}

.btn-change:hover {
    background-color: #84d7ff;
}

.action_close_modal {
    margin-bottom: 10px;
    height: 10px;
}

.upload-file {
    border: 2px solid rgb(168, 167, 167);
    border-style: dashed;
    border-radius: 15px;
}

.block_upload_file {
    justify-content: center;
    margin: 40px 0;
    text-align: center;
}

.upload-file {
    padding: 40px 10px;
    text-align: -webkit-center;
}

.upload-file .tittle {
    margin: 10px 0;
}

.justify-content-center {
    display: flex;
    justify-content: center;
}

.block_icon_upload {
    background-color: #d7f0fe;
    padding: 10px 25px;
    border-radius: 10px;
}

.btn-agree {
    margin-left: 10px;
    background: #0f3dba;
    color: white;
    line-height: 19px;
}

.wrap-file-data {
    .wrap-left {
        .name-file {
            max-width: 285px;
            text-overflow: ellipsis;
            overflow: hidden;
            margin-left: 5px;
        }

        .icon-photo {
            width: 30px;
            height: 30px;
        }
    }

    .wrap-right {
        .size-file {
            margin-right: 5px;
            color: #7a7777;
        }

        .btn-delete {
            cursor: pointer;
            width: 20px;
            height: 20px;
        }
    }
}

.upload-drag {
    border: 2px dashed #46b5e1 !important;
    opacity: 0.5;
}

.justify-content-right {
    justify-content: right;
    display: flex;
}

.btn-delete-question,
.btn-delete-question:hover {
    background-color: red;
    border: red;
    color: white;
}

.cursor-pointer {
    cursor: pointer;
}
</style>
